<template>
  <div>
    <slot v-if="!validBrowser">
      <base-alert outlined tile type="warning">
        <template #message>
          <p>{{ $t('app.outdatedBrowser.message') }}</p>
          <ul>
            <li>
              <a href="https://www.microsoft.com/en-us/edge/" target="_blank">{{
                $t('app.outdatedBrowser.newedge')
              }}</a>
            </li>
            <li>
              <a href="https://www.mozilla.org/firefox/new/" target="_blank">{{
                $t('app.outdatedBrowser.firefox')
              }}</a>
            </li>
            <li>
              <a href="https://www.google.com/chrome/" target="_blank">{{
                $t('app.outdatedBrowser.googlechrome')
              }}</a>
            </li>
          </ul>
        </template>
      </base-alert>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'BaseOutdatedBrowser',
  data() {
    return {
      validBrowser: window.DpValidBrowser,
    }
  },
}
</script>
